/* eslint-disable import/prefer-default-export */

/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

export const BLOG_CATEGORY_LISTING = 'blog-category-listing';
export const CATEGORY_DISPLAY_MODE_MAGAZINE = 4;
export const CATEGORY_DISPLAY_MODE_EVENTS = 5;
export const CATEGORY_DISPLAY_MODE_SPECIAL_OFFERS = 6;
export const CATEGORY_DISPLAY_MODE_NEWS = 7;
// TODO NEEED NEW EVENTS LAYOUT ID
export const CATEGORY_DISPLAY_MODE_NEW_EVENTS = 8;
